
//  import { WinnersAbout,  WinnersCities, WinnersFAQ, WinnersFooter, WinnersHeader, WinnersInsights, WinnersStats, WinnersTestimonials, WinnersTopProjects, WinnersUpcoming, WinnersWallOfFame } from "../NewHome2/Homelan";
import "./WinnerLand.css";
import cityImg from "../../../Images/city-skyline.jpg";
import heroImg from "../../../Images/hero-villa.jpg";
import towerImg from "../../../Images/property-tower.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import { WinnersBanner } from "./WinnersBanner";
import { WinnersHeader } from "./WinnersHeader";
// import { WinnersStats } from "../NewHome2/Homelan";
import { WinnersCities } from "./WinnersCities";
import { WinnersInsights } from "./WinnersInsights";
import { WinnersTopProjects } from "./WinnersTopProjects";
import { WinnersUpcoming } from "./WinnersUpcoming";
import { WinnersAbout } from "./WinnersAbout";
import { WinnersWallOfFame } from "./WinnersWallOfFame";
import { WinnersTestimonials } from "./WinnersTestimonials";
import { WinnersFAQ } from "./WinnersFAQ";
import { WinnersFooter } from "./WinnersFooter";
import WinnersStats from "./WinnersStats";
function WinnersLand() 
{
    const cityData = [
  {
    name: "Gurgaon",
    tag: "NCR",
    count: "1240",
    img: cityImg,
  },
  {
    name: "Lucknow",
    tag: "UP",
    count: "980",
    img: heroImg,
  },
  {
    name: "Noida",
    tag: "NCR",
    count: "1560",
    img: towerImg,
  },
  {
    name: "Dwarka",
    tag: "Delhi",
    count: "890",
    img: interiorImg,
  },
];
  return (
    <>
      <WinnersHeader />
      <WinnersBanner />
      <WinnersStats />
      <WinnersCities
  eyebrow="Popular Cities"
  title="Explore Top Locations"
  description="Discover premium properties in India's fastest growing cities."
  cities={cityData}
/>
      <WinnersInsights />
      <WinnersTopProjects />
      <WinnersUpcoming />
      <WinnersAbout />
      <WinnersWallOfFame />
      <WinnersTestimonials />
      <WinnersFAQ />
      <WinnersFooter />
    </>
  );
}

export default WinnersLand;